import loginPrompt from "emun.auth/login-prompt";

export default ($parse) => ({
  scope: false,
  link(scope, element, attr) {
    var ngModel = {
      open(e) {
        return loginPrompt(attr).then(
          (args) => $parse(attr.onAuthenticated)(scope, args),
          (args) => $parse(attr.onDismissed)(scope, args)
        );
      },
    };

    if (attr.ngModel) $parse(attr.ngModel).assign(scope, ngModel);

    var $targets = attr.loginPromptSelector
      ? element.find(attr.loginPromptSelector)
      : element;
    $targets.on("click", ngModel.open);
  },
});
